import { Button } from '@factorialco/deprecated-design-system'
import { UninviteEmployeeDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  accessId: string
  onClose: () => void
}

const UninviteModal = ({ accessId, onClose }: Props) => {
  const [uninviteEmployee] = useMutation(UninviteEmployeeDocument, {
    extractorFn: (data) => data.apiCoreMutations.uninviteApicoreAccess,
    update: (cache, { data }) => {
      const accessIdFromResponse =
        data?.apiCoreMutations?.uninviteApicoreAccess?.access?.id || accessId
      if (accessIdFromResponse) {
        cache.modify({
          id: cache.identify({ __typename: 'ApiCoreAccess', id: accessIdFromResponse }),
          fields: {
            invitedOn() {
              return null
            },
          },
        })
      }
    },
  })

  const onSubmit = async () => {
    const result = await uninviteEmployee({ variables: { accessId: accessId } })

    const handled = handleResult(result, (errors) => {
      if (errors) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('employees.uninvite.error'),
        })
      }
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('employees.uninvite.success'),
      })
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('employees.uninvite.action')}
      description={i18n.t('employees.uninvite.action_description')}
      illustration="single-neutral-actions"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('employees.uninvite.action')}</Button>
        </>
      }
    />
  )
}

export default UninviteModal
